/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ContactProfilePageRequestDto } from '../models/contact-profile-page-request-dto';
import { ContactProfilePageResponseDto } from '../models/contact-profile-page-response-dto';
import { StatisticsDto } from '../models/statistics-dto';

@Injectable({
  providedIn: 'root',
})
export class ContactProfileService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getContactProfilesStatistics
   */
  static readonly GetContactProfilesStatisticsPath = '/contact-profiles/{companyId}/statistics';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getContactProfilesStatistics()` instead.
   *
   * This method doesn't expect any request body.
   */
  getContactProfilesStatistics$Response(params: {
    companyId: string;
    facetSize?: number;
  }): Observable<StrictHttpResponse<StatisticsDto>> {

    const rb = new RequestBuilder(this.rootUrl, ContactProfileService.GetContactProfilesStatisticsPath, 'get');
    if (params) {
      rb.path('companyId', params.companyId, {});
      rb.query('facetSize', params.facetSize, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<StatisticsDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getContactProfilesStatistics$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getContactProfilesStatistics(params: {
    companyId: string;
    facetSize?: number;
  }): Observable<StatisticsDto> {

    return this.getContactProfilesStatistics$Response(params).pipe(
      map((r: StrictHttpResponse<StatisticsDto>) => r.body as StatisticsDto)
    );
  }

  /**
   * Path part for operation findContactProfiles
   */
  static readonly FindContactProfilesPath = '/contact-profiles';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findContactProfiles()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  findContactProfiles$Response(params?: {
    body?: ContactProfilePageRequestDto
  }): Observable<StrictHttpResponse<ContactProfilePageResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, ContactProfileService.FindContactProfilesPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ContactProfilePageResponseDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findContactProfiles$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  findContactProfiles(params?: {
    body?: ContactProfilePageRequestDto
  }): Observable<ContactProfilePageResponseDto> {

    return this.findContactProfiles$Response(params).pipe(
      map((r: StrictHttpResponse<ContactProfilePageResponseDto>) => r.body as ContactProfilePageResponseDto)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findContactProfiles$Csv()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  findContactProfiles$Csv$Response(params?: {
    body?: ContactProfilePageRequestDto
  }): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, ContactProfileService.FindContactProfilesPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/csv'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findContactProfiles$Csv$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  findContactProfiles$Csv(params?: {
    body?: ContactProfilePageRequestDto
  }): Observable<string> {

    return this.findContactProfiles$Csv$Response(params).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

  /**
   * Path part for operation findSimilarContactProfiles
   */
  static readonly FindSimilarContactProfilesPath = '/contact-profiles/similar';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findSimilarContactProfiles()` instead.
   *
   * This method doesn't expect any request body.
   */
  findSimilarContactProfiles$Response(params: {
    profileId: string;
    limit?: number;
  }): Observable<StrictHttpResponse<ContactProfilePageResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, ContactProfileService.FindSimilarContactProfilesPath, 'post');
    if (params) {
      rb.query('profileId', params.profileId, {});
      rb.query('limit', params.limit, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ContactProfilePageResponseDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findSimilarContactProfiles$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findSimilarContactProfiles(params: {
    profileId: string;
    limit?: number;
  }): Observable<ContactProfilePageResponseDto> {

    return this.findSimilarContactProfiles$Response(params).pipe(
      map((r: StrictHttpResponse<ContactProfilePageResponseDto>) => r.body as ContactProfilePageResponseDto)
    );
  }

}
